import React from 'react';
import { trackPixelEvent } from './MetaPixel';

/** Live checkout link, used by the checkout CTA in the price section. */
export const CHECKOUT_URL = 'https://the-young-inventor-lab.impultienda.ar/checkout';
interface CTAButtonProps {
  label: string;
  href?: string;
  external?: boolean;
  className?: string;
}
export function CTAButton({
  label,
  href = '#get-access',
  external = false,
  className = ''
}: CTAButtonProps) {
  return <a href={href} onClick={() => {
    if (href === CHECKOUT_URL) {
      trackPixelEvent('InitiateCheckout', {
        value: 69,
        currency: 'PLN'
      });
    }
  }} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`cta-button flex min-h-[54px] w-full items-center justify-center rounded-button bg-accent px-6 py-4 text-center text-base font-extrabold tracking-tight text-card shadow-lg shadow-accent/30 hover:bg-accent-strong focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent sm:text-[17px] ${className}`} data-id="element-78" data-mp="2txjim2h4zd4z">
      {label}
    </a>;
}